import { Space, Typography } from "antd";
import PropTypes from "prop-types";

import { SpinnerLoader } from "../../components/widgets/spinner-loader/SpinnerLoader";

function SummarizeStatusTitle({ profileName, isLoading }) {
  return (
    <Space className="w-100">
      <Typography.Text>Summary View</Typography.Text>
      <Typography.Text type="secondary">{profileName}</Typography.Text>
      {isLoading && <SpinnerLoader />}
    </Space>
  );
}

SummarizeStatusTitle.propTypes = {
  profileName: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export { SummarizeStatusTitle };
